var _ellipse, _path, _circle, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEmptyLinkedIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 128 126",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 121,
    rx: 50,
    ry: 5,
    fill: "#E9EBF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5678 119.954H26.4322C23.4321 119.954 21 117.522 21 114.521V67.3858C21 64.3857 23.4321 61.9536 26.4322 61.9536H73.5678C76.568 61.9536 79 64.3857 79 67.3858V114.521C79 117.522 76.568 119.954 73.5678 119.954Z",
    fill: "white",
    stroke: "#858DAC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 53,
    r: 37,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8558 86.8154C51.8558 86.0103 51.8422 85.2049 51.862 84.4003C51.8709 84.0336 51.7534 83.8959 51.373 83.8986C49.3943 83.9127 47.4153 83.9119 45.4366 83.8989C45.0738 83.8966 44.9384 83.9953 44.939 84.3823C44.9491 91.6727 44.9489 98.9633 44.9392 106.254C44.9387 106.632 45.0597 106.746 45.4302 106.744C47.5001 106.73 49.5702 106.729 51.6401 106.745C52.0167 106.747 52.1223 106.631 52.1209 106.256C52.1074 102.793 52.103 99.3302 52.12 95.8673C52.1242 95.0122 52.1767 94.1528 52.278 93.3038C52.3886 92.377 52.6854 91.5006 53.3367 90.7937C54.1729 89.8861 55.2591 89.6815 56.4317 89.7035C58.0685 89.7342 59.0884 90.4966 59.5561 92.0634C59.8575 93.0731 59.8816 94.1113 59.8821 95.1516C59.8841 98.8359 59.8825 102.52 59.8835 106.205C59.8837 106.719 59.9003 106.736 60.4064 106.737C62.4243 106.738 64.4421 106.738 66.4601 106.737C67.0891 106.737 67.0924 106.736 67.0898 106.116C67.0715 101.652 67.0596 97.1883 67.0276 92.7244C67.0178 91.3569 66.8343 90.0048 66.4598 88.6866C65.8865 86.6684 64.8064 85.0223 62.8226 84.1626C60.7471 83.2632 58.5735 83.1005 56.376 83.6396C54.4794 84.1048 52.9802 85.1692 51.8558 86.8154ZM40.6286 95.3422C40.6286 91.6974 40.6222 88.0526 40.6379 84.4079C40.6396 84.0123 40.534 83.894 40.1386 83.8972C38.082 83.9141 36.0252 83.913 33.9686 83.8979C33.5832 83.8951 33.4534 84.003 33.454 84.4048C33.4651 91.6814 33.465 98.9579 33.4541 106.234C33.4535 106.633 33.576 106.748 33.9655 106.745C36.0221 106.729 38.079 106.729 40.1355 106.745C40.5255 106.748 40.64 106.638 40.6382 106.237C40.6218 102.606 40.6286 98.974 40.6286 95.3422ZM32.91 76.8068C32.9104 79.0795 34.7717 80.9826 37.0477 80.9598C39.3963 80.9362 41.2186 79.1673 41.2144 76.8022C41.2101 74.3959 39.3548 72.6431 37.0433 72.6566C34.5784 72.6709 32.9144 74.6437 32.91 76.8068Z",
    stroke: "#858DAC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 77L84 69.7368V63.4421C82.5 61.9895 79.5 58.3095 79.5 55.2105C78.5 55.5333 77.5 55.2106 77.5 50.8527C77.5 45.5044 79.5 46.4947 80 46.9789C80.3763 47.3434 80.1921 42.0217 80.0301 38.8368C80.0107 38.4547 80.0173 38.0716 80.1106 37.7006C80.7484 35.1649 83.5805 31 91 31C98.7977 31 101.528 35.6004 101.97 38.075C101.993 38.2005 101.997 38.3254 101.99 38.4527C101.824 41.5713 101.608 47.3585 102 46.9789C102.5 46.4947 104.5 45.5044 104.5 50.8527C104.5 55.2106 103.5 55.5333 102.5 55.2105C102.5 58.3095 99.5 61.9895 98 63.4421V69.7368L111.5 77",
    stroke: "#858DAC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1L74 13.5M56 9L67 18.5M49 25L61.5 26.5M123 53C123 70.6731 108.673 85 91 85C73.3269 85 59 70.6731 59 53C59 35.3269 73.3269 21 91 21C108.673 21 123 35.3269 123 53Z",
    stroke: "#3953FB",
    strokeWidth: 2
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyLinkedIn.1f7d90c0.svg";
export { ForwardRef as ReactComponent };